import { get, post, put, destroy } from "./base";

const ProductsSoldServ = {
    // Get sales records
    getRecords: (params) => get("/products-sold", { params }),

    // Add a new sales record
    addRecord: (payload) => post("/products-sold", payload),

    // Update a sales record
    updateRecord: (id, payload) => put(`/products-sold/${id}`, payload),

    // Delete a record
    remove: (id) => destroy(`/products-sold/${id}`),
};

export default ProductsSoldServ;
